import React from 'react'

import { connect } from "react-redux"

import * as appActionCreators from "../actionCreators/app.js"
import * as authActionCreators from "../actionCreators/auth.js"

import FieldInputText from '../components/common/FieldInputText'
import FieldPassword from '../components/common/FieldPassword'

import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { Message } from 'primereact/message'

import { Form } from 'react-form'

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      details: {
      },
      isTokenValid: false
    }
  }

  sendPasswordLink = details => {
    this.props.setLoading(true)
      .then(() => this.props.sendPasswordLink(details.Email))
      .then(response => {
        this.props.setAjaxResponse(response)
        this.props.setLoading(false)
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  resetPassword = details => {
    let token = this.props.match.params.token
    details.Token = token
    this.props.setLoading(true)
      .then(() => this.props.resetPassword(details))
      .then(response => {
        this.props.setAjaxResponse(response)
        this.props.setLoading(false)
        if (response.data.Success) {
          this.props.history.push('/')
        }
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  componentDidMount() {
    let token = this.props.match.params.token
    if (token) {
      this.props.setLoading(true)
        .then(() => this.props.checkTokenValidity(token))
        .then(response => {
          this.props.setAjaxResponse(response)
          this.props.setLoading(false)
          if (response.data.Success) {
            this.setState({ isTokenValid: true })
          }
        })
        .catch((error) => this.props.handleError(error)
          .then(() => this.props.setLoading(false)))
    }
  }

  render() {
    let token = this.props.match.params.token
    return (
      <React.Fragment>
        {!token && <Form values={this.state.details} onSubmit={this.sendPasswordLink}>
          {formApi => {
            return (
              <Card >
                <div className="p-grid">
                  <div className="p-col-12 p-md-12 p-lg-12">
                    <FieldInputText field={"Email"} label={"Please enter your Email Address:"} />
                  </div>
                  <div className="p-helper-clearfix buttons">
                    <Button label="Send Reset Link" onClick={formApi.submitForm} />
                  </div>
                </div>
              </Card>
            )
          }}
        </Form>}
        {token && this.state.isTokenValid && <Form values={this.state.details} onSubmit={this.resetPassword}>
          {formApi => {
            return (
              <Card >
                <div className="p-grid">
                  <div className="p-col-12">
                    <Message style={{ width: '100%' }} severity="info" text="Password must be at least 8 characters, contain 1 digit, contain 1 uppercase letter and contain 1 lowercase letter."></Message>
                  </div>
                  <div className="p-col-12 ui-md-12 ui-lg-12">
                    <FieldPassword field={"Password"} label={"Please enter your New Password"} />
                  </div>
                  <div className="p-col-12 ui-md-12 ui-lg-12">
                    <FieldPassword field={"ConfirmPassword"} label={"Please confirm your New Password:"} />
                  </div>
                  <div className="p-helper-clearfix buttons">
                    <Button label="Reset Password" onClick={formApi.submitForm} />
                  </div>
                </div>
              </Card>
            )
          }}
        </Form>}
      </React.Fragment>
    )

  }
}

const mapStateToProps = (state) => {
  return state
}

const actionCreators = {
  ...appActionCreators,
  ...authActionCreators
}

export default connect(mapStateToProps, actionCreators)(ForgotPassword);


// WEBPACK FOOTER //
// ./src/container/ForgotPassword.js